/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Versions_Restore_DescriptionInputs */



/**
* | output |
* | --- |
* | "The app goes back to this version. Its current state stays in the history, so you can return to it." |
*
* @param {Canvas_Versions_Restore_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_versions_restore_description = /** @type {((inputs?: Canvas_Versions_Restore_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Versions_Restore_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die App wird auf diese Version zurückgesetzt. Ihr aktueller Stand bleibt im Verlauf, Sie können also jederzeit zurückkehren.")
	return /** @type {LocalizedString} */ ("The app goes back to this version. Its current state stays in the history, so you can return to it.")
});